import { routes } from "src/shared/routes";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import { FAQS, REGISTRATION_CARDS, TERMS_AND_CONDITION } from "./helper";

const desktopBannerImage =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/EmployeePostSeason/DesktopBanner.jpg";
const mobileBannerImage =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/EmployeePostSeason/MobileBanner.jpg";
const orderSummaryBackgroundUrl =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/EmployeePostSeason/Stadium.jpg";

export const dbacks_postseason: TTeamConfig = {
  TEAM_SCHEMA: "dbacks_postseason",
  TEAM_FULL_NAME: "Arizona Diamondbacks",
  BROWSER_TITLE: "Arizona Diamondbacks",
  CLIENT_ID: "64dd97c850f6.seasonshare.azdbacks-azdbacks.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#A71930",
    COLORS_SECONDARY: "#E3D4AD",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,

    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    NAV_MENU: {
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_EARN_REWARDS: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    HIDE_EVENT_BANNER: true,
    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
    EVENT_CARD: {
      ADD_ON_DISPLAY_MODE: "grouped",
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/MLB-3/AZD-UPDATED.png",
    LANDING_PAGE_STATIC_BANNER_URL: desktopBannerImage,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: desktopBannerImage,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileBannerImage,
    ORDER_SUMMERY_BACKGROUND_URL: orderSummaryBackgroundUrl,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
